module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r1n4n8r-4639986dbea4b5b211d09805b6a7465e.svg";